import React from 'react';
import 'react-chat-elements/dist/main.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { awsConfig } from './configs/aswConfig';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { setupInterceptors } from 'api/apiClient';
import { Amplify } from 'aws-amplify';
import 'normalize.css';

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

setupInterceptors(store.dispatch);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
